module.exports = __webpack_public_path__ + "static/media/8_of_clubs.7f5bfbac.png";